import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
import { cn } from "@/lib/utils";
import { Typography } from "@bookips/sds";
import Link from "next/link";
const CategorySectionComponent = (param)=>{
    let { title , titleLink , items , onItemClick , selectedId , className , variant ="default" , isLast =false  } = param;
    const handleGroupClick = (groupTitle)=>{
        mixpanelEvent("Category Board Item Clicked", {
            "Item Type": "Group",
            "Item Name": groupTitle
        });
    };
    const handleItemClick = (item)=>{
        mixpanelEvent("Category Board Item Clicked", {
            "Item Type": "Group Item",
            "Item Name": item.itemTitle
        });
        onItemClick === null || onItemClick === void 0 ? void 0 : onItemClick(item);
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: cn("py-2.5", variant === "mobile" && !isLast && "border-b border-gray-100", className),
        children: [
            title && /*#__PURE__*/ _jsx("div", {
                className: "px-4 py-2 hover:text-primary-main hover:underline transition-colors group",
                children: titleLink ? /*#__PURE__*/ _jsx(Link, {
                    href: titleLink,
                    className: "block",
                    onClick: ()=>handleGroupClick(title),
                    children: /*#__PURE__*/ _jsx(Typography, {
                        variant: "subtitle1",
                        className: "break-keep text-primary group-hover:text-primary-main group-hover:underline transition-colors",
                        children: title
                    })
                }) : /*#__PURE__*/ _jsx(Typography, {
                    variant: "subtitle1",
                    className: "break-keep text-primary group-hover:text-primary-main group-hover:underline transition-colors",
                    children: title
                })
            }),
            /*#__PURE__*/ _jsx("ul", {
                children: items.map((item)=>{
                    const isSelected = selectedId === String(item.itemSeq);
                    return /*#__PURE__*/ _jsx("li", {
                        children: /*#__PURE__*/ _jsx("button", {
                            type: "button",
                            onClick: ()=>handleItemClick(item),
                            className: cn("w-full px-4 py-2 text-left typo-body2 transition-colors break-keep", "hover:text-primary-main hover:underline", isSelected ? "text-primary-main font-semibold" : "text-primary"),
                            children: item.itemTitle
                        })
                    }, item.itemSeq);
                })
            })
        ]
    });
};
export default CategorySectionComponent;
